const escapeAttributeValue = (value: string) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')

export const buildBaseHtml = (
  templateContent: string,
  templateFieldData?: Record<string, string>,
): string => {
  if (!templateContent) return ''
  if (!templateFieldData || Object.keys(templateFieldData).length === 0) return templateContent

  const parser = new DOMParser()
  const doc = parser.parseFromString(templateContent, 'text/html')

  Object.entries(templateFieldData).forEach(([key, value]) => {
    const escapedKey = escapeAttributeValue(key)
    const element = doc.querySelector(`[name="${escapedKey}"]`) || doc.getElementById(key)
    if (element instanceof HTMLImageElement) {
      element.src = value
    }
  })

  doc.querySelectorAll('input.datepicker').forEach((el) => {
    el.setAttribute('type', 'date')
  })

  return doc.body.innerHTML
}

export const mapSubmitDocTemplateErrorMessage = (rawMessage?: string): string => {
  const message = (rawMessage || '').trim()
  if (!message) return 'Failed to sign document'

  const normalized = message.toLowerCase()

  if (
    (normalized.includes('patient') && normalized.includes('signature')) ||
    normalized.includes('default signature') ||
    normalized.includes('add the patient signature')
  ) {
    return 'Patient Signature is missing'
  }

  if (
    (normalized.includes('physician') && normalized.includes('signature')) ||
    (normalized.includes('admin') && normalized.includes('signature')) ||
    normalized.includes('adminsignature')
  ) {
    return 'Physician Signature is missing'
  }

  if (normalized.includes('witness') && normalized.includes('signature')) {
    return 'Witness Signature is missing'
  }

  if (normalized.includes('witness') && normalized.includes('name')) {
    return 'Witness Name is missing'
  }

  return message
}
